import { trigger, transition, style, animate } from "@angular/animations";

export const InOutAnimation =
  [trigger('inOutAnimation', [
    transition('void => *', [
      style({ opacity: 0 }),
      animate('1s ease-out', style({ opacity: 1 })),
    ]),
    transition('* => void', [
      style({ opacity: 1 }),
      animate('0s ease-in', style({ opacity: 0 })),
    ]),
  ])];

  export const disableOutAnimation =
  [trigger('disableOutAnimation', [
    transition('* => void', [
      style({ opacity: 1 }),
      animate('0s ease-in', style({ opacity: 0 })),
    ]),
  ])];